import { useMemo } from 'react';
import type { Key } from '@theory/keys';
import { buildKeyForMode, decodeKeyId } from '@util/musicTheory';
import { useAppStore } from '@app/store/useAppStore';

export function useKey(keyId: string): Key | null {
  const selectedMode = useAppStore((s) => s.selectedMode);

  return useMemo(() => {
    if (!keyId) return null;
    const decoded = decodeKeyId(keyId);
    if (!decoded) return null;
    try {
      return buildKeyForMode(decoded.root, selectedMode);
    } catch {
      return null;
    }
  }, [keyId, selectedMode]);
}
